var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 99.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,11.44H33.85c9.25.05,17.12,2.17,23.74,6.15L73.45,29.78,90.16,7.25C94.77,1.3,99.66-.28,105.72,0c3,.15,6.77.27,8.74,2.85,1.25,1.65,1,2.37.51,4.11l-.74,2.51c-1.28,2.66-3,4.26-5.31,4.82l-2.62,0c-4.92,0-7.84.3-11.54,4.15L80.66,35.33,83,37.14l25.42,1.67c5.18-.14,9.16,1.64,10.67,7.27V63.24c7.18,1.84,2.5,18.4-.72,22-2.84,3.2-5.42,2.83-9.22,2.83H86.51c4.35-32.74-29-39.73-42.77-21.9-4.54,5.89-5.22,13.92-3.34,23.36H0V11.44ZM63.06,62.52A18.42,18.42,0,1,1,44.64,80.94,18.42,18.42,0,0,1,63.06,62.52Zm2.16,9.63v6.63h6.64a9.07,9.07,0,0,0-6.64-6.63ZM71.86,83.1H65.22v6.64a9.07,9.07,0,0,0,6.64-6.64Zm-11,6.64V83.1H54.27a9.07,9.07,0,0,0,6.63,6.64Zm-6.63-11H60.9V72.15a9.08,9.08,0,0,0-6.63,6.63ZM48.46,44.11l3.46-20.4L64.1,39.06l-2.29,2.59-2.16,2.46ZM11.83,16,7.67,43.91H44.6l3.66-25c-15.21-3.7-21.58-3-36.43-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCar);
export default __webpack_public_path__ + "static/media/open-car.f08eb46e.svg";
export { ForwardRef as ReactComponent };